<template>
  <div class="admin-layout">
    <a class="skip-link" href="#admin-main-content">
      {{ $t('AccessibilityToolbar.skipToContent') }}
    </a>
    <div class="w-sm-100 d-md-flex">
      <nav
        class="nav-desktop"
        style="z-index: 5"
        :aria-label="$t('AdminMain.nav_label')"
      >
        <NavigationAdmin :wlistener="innerWidth" />
      </nav>
      <div class="w-100 admin-content">
        <AdminTopHeader />

        <main
          id="admin-main-content"
          class="pt-4 px-2 px-md-3 px-lg-4"
          tabindex="-1"
        >
          <!-- <AccessibilityToolbar /> -->
          <router-view></router-view>
        </main>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NavigationAdmin from "@/app/layout/components/NavigationAdmin.vue";
import AccessibilityToolbar from "@/app/common/components/AccessibilityToolbar.vue";
import AdminTopHeader from "@/app/layout/components/AdminTopHeader.vue";

export default {
  name: "AdminMain",
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  components: { NavigationAdmin, AccessibilityToolbar, AdminTopHeader },
  methods: {
    innerWidthChanged() {
      // console.log("resize handler");
      this.innerWidth = window.innerWidth;
    },
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
  created() {
    if (this.user.type !== 2) {
      this.$router.push({ name: "Home" });
    }
  },
};
</script>

<style scoped>
.admin-layout {
  position: relative;
}

/* la colonna contenuto è un flex item di .d-md-flex: la utility .w-100 impone width:100%
   ma lascia min-width:auto, quindi non potrebbe rimpicciolirsi sotto il min-content del
   proprio contenuto e allargherebbe l'intera pagina. min-width:0 la mantiene contenuta
   (coerente con la colonna contenuto di operatore e cittadino). */
.admin-content {
  min-width: 0;
}

.skip-link {
  position: absolute;
  top: -40px;
  left: 10px;
  background-color: #ffffff;
  color: #000;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  z-index: 3000;
}

.skip-link:focus {
  top: 10px;
}
</style>
